import { combineReducers } from 'redux';
import { requestsReducer } from 'redux-requests';
import reduceReducer from 'reduce-reducers';
import asyncReducer from './asyncReducer';
import syncReducer from './syncReducer';
import file from './file';

export default combineReducers({
  domain: reduceReducer(asyncReducer, syncReducer),
  requests: requestsReducer,
  files: file
});
